var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md:flex md:items-center md:justify-between pb-10"},[_c('div',{staticClass:"flex-1 min-w-0"},[_c('h1',{staticClass:"text-gray-900"},[_vm._t("title")],2)]),_vm._t("interactive")],2)}
var staticRenderFns = []

export { render, staticRenderFns }